// npm packages
import React, { useState, useEffect, useContext } from "react";
import { useHistory, useLocation } from "react-router-dom";
import { useTranslation } from 'react-i18next';
// custom pages
import { Styles } from "./styles";
import TransactionsApi from "apis/transactions/transactions";
import Context from "context/context";

// material-ui
import Button from "@material-ui/core/Button";

// material-ui icons
import Grid from "@material-ui/core/Grid";

function ViewOverWrite() {
  const { state, dispatch } = useContext(Context);
  const { getTransaction } = TransactionsApi();
  const history = useHistory();
  const location = useLocation();
  const offsetParams = location?.state?.offset;
  const searchValueParams = location?.state?.searchValue;
  const classes = Styles();
  const [data, setData] = useState({});
  const{t,i18n}=useTranslation()
  // For bread-crumbs
  useEffect(() => {
    dispatch({
      type: "SET_PATHNAME",
      payload: ["HOME", "ADMIN", "Points Adjustment"],
    });
  }, []);

  // handling api calls
  useEffect(() => {
    if (location?.state?.transactionId) {
      handleGet();
      return;
    }
    history.goBack();
  }, []);

  // authorized members api func
  const handleGet = async () => {
    try {
      let id = location?.state?.transactionId;
      let res = await getTransaction(id);
      if (res) {
        setData(res?.data);
      }
    } catch (e) {
      console.log({ e });
    }
  };

  const pointFormat = (point) => {
    var nfObject = new Intl.NumberFormat("en-US");
    var res = nfObject.format(point);
    return res;
  };

  return (
    <React.Fragment>
      <Grid container className={classes.gridContainer}>
        <Grid item xs={6}>
          <Button
            className={classes.editBtn}
            onClick={() => {
              history.goBack()
            }}
          >
            {t('Back')}
          </Button>
        </Grid>
      </Grid>
      <Grid container>
        <div className={classes.firstDiv}>
          <div className={classes.secondDiv}>{t('Loyalty Transaction Details')}</div>
          <div className={classes.type}>{`${data.type} Transaction`}</div>
        </div>
        <Grid xs={12} sm={6} className={classes.grid}>
          <div>
            <span className={classes.gridSpan}>{t('Transaction Id')}</span> :{" "}
            {data?.transaction_id}
          </div>
        </Grid>
        <Grid xs={12} sm={6} className={classes.grid}>
          <div>
            <span className={classes.gridSpan}>{t('Member ID')}</span> :{" "}
            {data?.loyalty_id}
          </div>
        </Grid>
        <Grid xs={12} sm={6} className={classes.grid}>
          <div>
            <span className={classes.gridSpan}>{t('Order ID')}</span> :{" "}
            {data?.order_id}
          </div>
        </Grid>
        <Grid xs={12} sm={6} className={classes.grid}>
          <div>
            <span className={classes.gridSpan}>{t('Customer Account Number')}</span> :{" "}
            {data?.customer_account_number}
          </div>
        </Grid>
        <Grid xs={12} sm={6} className={classes.grid}>
          <div>
            <span className={classes.gridSpan}>
              {t('Customer Billto Account Number')}
            </span>{" "}
            : {data?.customer_billto_account_number}
          </div>
        </Grid>
        <Grid xs={12} sm={6} className={classes.grid}>
          <div>
            <span className={classes.gridSpan}>{t('Program Admin')}</span> :{" "}
            {data?.["User.email"]}
          </div>
        </Grid>
      </Grid>

      <Grid container>
        <div className={classes.firstDiv}>
          <div className={classes.secondDiv}>{t('Promotional Details')}</div>
        </div>
        <Grid xs={12} sm={6} className={classes.grid}>
          <div>
            <span className={classes.gridSpan}>{t('Rule ID')}</span> : {data?.rule_id}
          </div>
        </Grid>
        <Grid xs={12} sm={6} className={classes.grid}>
          <div>
            <span className={classes.gridSpan}>{t('Extended Sales Amount')}</span> :{" "}
            {data?.extended_sales_amount?.toLocaleString(undefined, {
              minimumFractionDigits: 2,
              maximumFractionDigits: 2,
            })}
          </div>
        </Grid>
        <Grid xs={12} sm={6} className={classes.grid}>
          <div>
            <span className={classes.gridSpan}>{t('Promotional Description')}</span> :{" "}
            {data?.rule_description}
          </div>
        </Grid>
        <Grid xs={12} sm={6} className={classes.grid}>
          <div>
            <span className={classes.gridSpan}>{t('Points Earned')}</span> :{" "}
            {pointFormat(data?.points)}
          </div>
        </Grid>
      </Grid>

      <Grid container>
        <div className={classes.firstDiv}>
          <div className={classes.secondDiv}>{t('Order Details')}</div>
        </div>
        <Grid xs={12} sm={6} className={classes.grid}>
          <div>
            <span className={classes.gridSpan}>{t('Transaction Status')}</span> :{" "}
            <span
              className={
                data?.transaction_status === "Processed"
                  ? classes.processed
                  : ""
              }
            >
              {data?.transaction_status}
            </span>
          </div>
        </Grid>
        <Grid xs={12} sm={6} className={classes.grid}>
          <div>
            <span className={classes.gridSpan}>{t('Transaction Type')}</span> :{" "}
            {data?.transaction_type}
          </div>
        </Grid>
        <Grid xs={12} sm={6} className={classes.grid}>
          <div>
            <span className={classes.gridSpan}>{t('Date of Transaction')}</span> :{" "}
            {data?.date_of_transaction}
          </div>
        </Grid>
        <Grid xs={12} sm={6} className={classes.grid}>
          <div>
            <span className={classes.gridSpan}>{t('Shipment Date')}</span> :{" "}
            {data?.post_date}
          </div>
        </Grid>
        <Grid xs={12} sm={6} className={classes.grid}>
          <div>
            <span className={classes.gridSpan}>{t('Brand Code')}</span> :{" "}
            {data?.product_brand_name_code}
          </div>
        </Grid>
        <Grid xs={12} sm={6} className={classes.grid}>
          <div>
            <span className={classes.gridSpan}>{t('Business Unit Code')}</span> :{" "}
            {data?.gl_cost_center_code}
          </div>
        </Grid>
        <Grid xs={12} sm={6} className={classes.grid}>
          <div>
            <span className={classes.gridSpan}>{t('Product Description')}</span> :{" "}
            {data?.product_short_description}
          </div>
        </Grid>
        <Grid xs={12} sm={6} className={classes.grid}>
          <div>
            <span className={classes.gridSpan}>{t('Business Unit Description')}</span>{" "}
            : {data?.business_unit_description}
          </div>
        </Grid>
        <Grid xs={12} sm={6} className={classes.grid}>
          <div>
            <span className={classes.gridSpan}>
              {t('Line of Business Description')}
            </span>{" "}
            : {data?.line_of_business_description}
          </div>
        </Grid>
      </Grid>
    </React.Fragment>
  );
}

export default ViewOverWrite;
